import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../../HTH";

export class FillUpPresentation implements SimplePresentation {
    name: string = "FillUpPresentation";

    shouldRun(): boolean {
        return HTH.model.isCurrentAvalanche;
    }

    start(controller: SimplePresentationRunnerController): void {
        const fillUpTl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                HTH.reelArea.allReels[5].reelView.stopScatterAnticipation();
                HTH.reelAnticipation.reset();
                HTH.reelArea.makeBlurFilterNull();
                controller.setSkipCallback();
                controller.finish();
            }
        });
        fillUpTl.add(() => {
            controller.setSkipCallback(() => {
                fillUpTl.seek("fillupComplete", false);
            });
        }, 0.5);
        fillUpTl.to(this, {duration: 0.2});
        fillUpTl.add(HTH.reelArea.fillUp(), 0.2);
        if (HTH.model.nearWinReels.includes(true)) {
            fillUpTl.add(HTH.reelArea.allReels[5].reelView.stopScatterAnticipation());
            fillUpTl.add(() => {
                HTH.reelAnticipation.reset();
            })
        }
        fillUpTl.addLabel("fillupComplete");
        fillUpTl.add(() => {
            HTH.reelArea.ebSpinArea.isEnhancerSpinning = false;
            controller.setSkipCallback();
        })
        fillUpTl.to(this, {duration: 0.02});
        /* if (HTH.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
             fillUpTl.timeScale(1.4);
         }*/
    }
}